import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { MonteCarloPercentilesDTO } from '../types/monteCarlo.types';
import { queryKeys } from './queryKeys';

const fetchMarketScenarios = async (
  clientId: number,
  fpId: string | null,
): Promise<MonteCarloPercentilesDTO> => {
  return authFetch(
    urlWithParams('/Consumer/MC/Percentiles', {
      clientId,
      fpId,
    }),
  );
};

interface UseMarketScenariosQueryParams {
  clientId: number;
  fpId: string;
  enabled?: boolean;
}

export const useMarketScenariosQuery = ({
  clientId,
  fpId,
  enabled = true,
}: UseMarketScenariosQueryParams) => {
  return useQuery(
    queryKeys.marketScenarios(clientId, fpId),

    () => fetchMarketScenarios(clientId, fpId),
    {
      enabled,
    },
  );
};
